import React, {useReducer, useRef, useState} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import FeatureName from "../../visComponents/featureName";
import AllFeaturesChecker from "../../visComponents/allFeaturesChecker";
import {EditIcon} from "../../common/icons";
import {getCurrentLayout} from "../../appLayout";
import {useOutsideClick} from "../../../misc/helperHooks";
import sqftShapeManager from "../../sqft/components/canvas/store/sqftShapeManager";
import {getNavItemsFromTheWizard} from "../../sqft/helpers/sqftHelperUi";
import sqftShapeIntersectionsManager from "../../sqft/components/canvas/store/sqftShapeIntersectionsManager";
import {prepareSQFTData} from "../../sqft/components/canvas/core/workspace/workspaceDataMapper";
import {saveSQFTDataToQuote} from "../../sqft/helpers/sqftQuotesHelper";

const filterNavItemsWithSearch = (navItems, productText) => {
  if (!productText) {
    return navItems
  }
  const searchString = productText.toLowerCase();
  return navItems.filter(navItem => {
    const name = navItem && navItem.part && navItem.part.getFeatureName ? navItem.part.getFeatureName() : "";
    return name && name.toLowerCase().includes(searchString)
  })
}

const SqftFeaturesPopupFeatureDropdown = (props) => {

  const {parentsList, rebuildQuoteLists, parentKey, sqftFeatureIndex, editButtonColor} = props;
  const {wizardIsActive} = props;
  const {feature, subPart, fromWizardGroupId} = parentsList[parentKey].features[sqftFeatureIndex];

  const [productText, setProductText] = useState("");
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [ignored, forceUpdate] = useReducer(x => x + 1, 0);
  const dropdownElement = useRef(null);
  const inputElement = useRef(null);

  useOutsideClick(dropdownElement, () => {
    setDropdownVisible(false);
  }, true);

  const handleInputChange = (event) => {
    setProductText(event.target.value);
  }

  const handleNavItemClick = async (navItem) => {
    navItem.part.handleClick();
    // update feature in calculator
    sqftShapeManager.setShapeFeature(parentsList[parentKey].features[sqftFeatureIndex].sqftId, navItem.part);
    sqftShapeManager.updateShapeColorSet(parentsList[parentKey].features[sqftFeatureIndex].sqftId);
    sqftShapeIntersectionsManager.updateSlabPlaceholderFeatureId();

    // //update parentList with new navItem
    // let updatedLists = [...parentsLists];
    // let updatedList = {...parentsList};
    // const parentListIndex = parentsLists.findIndex(pList => pList === parentsList);
    // updatedList[parentKey].features[sqftFeatureIndex].feature = navItem.part;
    // if (navItem.newWizardGroupId) {
    //   // updatedList[parentKey].features[sqftFeatureIndex].fromWizardGroupId = navItem.newWizardGroupId;
    //   // we can't do that, we need to have all features, from all groups, so we can't pass direct group id here
    //   updatedList[parentKey].features[sqftFeatureIndex].newWizardGroupId = navItem.newWizardGroupId;
    //   // console.log("updated!", updatedList[parentKey].features[sqftFeatureIndex]);
    // }
    // if (isRecalculateSlabNeeded(parentsList)) {
    //   updatedList = recalculateSlabs(updatedList);
    // }
    // updatedLists[parentListIndex] = updatedList;
    // setParentsLists(updatedLists);

    let sqftCalcData = await prepareSQFTData();
    await saveSQFTDataToQuote(sqftCalcData);
    // wi will update parent list on quotes change
    void rebuildQuoteLists;
    setDropdownVisible(false);
  };

  const getNamesArray = () => {
    if (dropdownVisible) {
      if (!subPart.part.allFeaturesReceived) {
        return [{loader: true}]
      }
      if (wizardIsActive) {
        const wizNavItems = getNavItemsFromTheWizard(subPart, "", {}, fromWizardGroupId, visualizerType, true);
        return filterNavItemsWithSearch(wizNavItems, productText)
      }
      const layout = getCurrentLayout();
      const navItems = layout.designNavigationItems(subPart, {}, "", false, true);
      return filterNavItemsWithSearch(navItems, productText);
    }
    return []
  }

  const editButtonClick = () => {
    if (dropdownVisible) {
      setDropdownVisible(false)
    } else {
      setDropdownVisible(true);
      if (inputElement && inputElement.current) {
        inputElement.current.focus()
      }
    }
  };

  const visualizerType = parentsList.quote ? parentsList.quote.room : document.kvConfig.visualizerType;
  const namesArray = getNamesArray();

  const styles = {
    height: dropdownVisible ? namesArray.length * 30 + 32 : 0,
    width: dropdownVisible ? "100%" : 0,
  }

  return (
    <div className="sqft-popup__feature-name" ref={dropdownElement}>
      <button className="sqft-popup__feature-edit" onClick={editButtonClick} >
        <EditIcon color={editButtonColor}/>
      </button>
      {feature
        ? <FeatureName feature={feature}/>
        : <FormattedMessage id="sqftFeaturesPopup.noFeatureSelected"/>}
      <div className="sqft-popup__dropdown aq-dropdown" style={styles}>
        <input className="ui-input ui-input--new ui-input--gray"
               value={productText}
               ref={inputElement}
               onChange={handleInputChange}/>
        <ul className="aq-list">
          {namesArray.map((navItem, navItemIndex) => {
            return navItem.loader ? (
              <AllFeaturesChecker subPart={subPart}
                                  key="aq-list-loader" ignored={ignored} callBack={forceUpdate}/>
            ) : (
              <li className="aq-list__item" key={navItemIndex} onClick={() => handleNavItemClick(navItem)}>
                <FeatureName feature={navItem.part}/>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
};

SqftFeaturesPopupFeatureDropdown.propTypes = {
  parentsList: PropTypes.object.isRequired,
  parentsLists: PropTypes.array.isRequired,
  setParentsLists: PropTypes.func.isRequired,
  editButtonColor: PropTypes.string.isRequired,
  parentKey: PropTypes.string.isRequired,
  sqftFeatureIndex: PropTypes.number.isRequired,
}

const mapStateToProps = (store) => {
  return {
    activeTheme: store.serverState.activeTheme,
    wizardIsActive: store.wizardState.wizardIsActive,
  };
};
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SqftFeaturesPopupFeatureDropdown)
